import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import AppProviders from "./context/AppContext";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import About from "./pages/About";
import ArtistOnboarding from "./pages/ArtistOnboarding";
import ChangePassword from "./pages/ChangePassword";
import FindTickets from "./pages/FindTickets";
import AdminDashboard from "./pages/admin/Dashboard";
import ApporteurDashboard from "./pages/apporteur/Dashboard";
import ArtistFanpage from "./pages/artist/Fanpage";
import ArtistManagement from "./pages/artist/Management";
import ArtistAccount from "./pages/artist/Account";
import FanAccount from "./pages/fan/Account";
import EventDetail from "./pages/EventDetail";
import TicketScanner from "./pages/TicketScanner";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import VerifyEmail from "./pages/VerifyEmail";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import SetPassword from "./pages/SetPassword";
import SupportButton from "./components/SupportButton";

function App() {
  return (
    <AppProviders>
      <div className="App min-h-screen bg-background text-foreground">
        <Toaster 
          position="top-right" 
          richColors 
          toastOptions={{
            style: {
              background: 'hsl(var(--card))',
              color: 'hsl(var(--card-foreground))',
              border: '1px solid hsl(var(--border))',
            },
          }}
        />
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/devenir-artiste" element={<ArtistOnboarding />} />
            <Route path="/changer-mot-de-passe" element={<ChangePassword />} />
            <Route path="/retrouver-billets" element={<FindTickets />} />
            <Route path="/find-tickets" element={<FindTickets />} />
            
            {/* Admin Routes */}
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            
            {/* Apporteur Routes */}
            <Route path="/apporteur/dashboard" element={<ApporteurDashboard />} />
            
            {/* Stripe Checkout Routes */}
            <Route path="/checkout/success" element={<CheckoutSuccess />} />
            <Route path="/checkout/cancel" element={<CheckoutCancel />} />
            
            {/* Artist/Tenant Routes */}
            <Route path="/:artistSlug" element={<ArtistFanpage />} />
            <Route path="/:artistSlug/fanpage" element={<ArtistFanpage />} />
            <Route path="/:artistSlug/management" element={<ArtistManagement />} />
            <Route path="/:artistSlug/management/*" element={<ArtistManagement />} />
            <Route path="/:artistSlug/account" element={<ArtistAccount />} />
            <Route path="/:artistSlug/fan/account" element={<FanAccount />} />
            <Route path="/:artistSlug/event/:eventId" element={<EventDetail />} />
            <Route path="/:artistSlug/scanner" element={<TicketScanner />} />
            <Route path="/:artistSlug/payment/success" element={<PaymentSuccess />} />
            <Route path="/:artistSlug/payment/cancel" element={<PaymentCancel />} />
            
            {/* Fan Login/Register */}
            <Route path="/:artistSlug/login" element={<Login />} />
            <Route path="/:artistSlug/register" element={<Register />} />
          </Routes>
          {/* Global Support Button */}
          <SupportButton variant="floating" />
        </BrowserRouter>
      </div>
    </AppProviders>
  );
}

export default App;
